module.exports = __webpack_public_path__ + "img/em-energymonitor-studies-04.20d879d9.webp";